 
import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {Controller} from 'react-hook-form';
import Tooltip from 'antd/lib/tooltip';

import {fetchSelectData, countries} from './../../../../utils';
import SelectInput from '../../../../components/ui/Inputs/SelectInput/SelectInput';
import ContainerCard from '../../../../components/ui/ContainerCard';
import TextInput from '../../../../components/ui/Inputs/TextInput';
import TextAreaInput from '../../../../components/ui/Inputs/TextAreaInput';
import Button from '../../../../components/ui/Button';
import {ContractorActions, LocationActions, ContractorCategoryActions} from '../../../../actions';
import {notify} from '../../../../components/ui/Toast/Toast';
import {UserActions} from '../../../../actions';
import Error from '../../../../components/ui/Error/Error';
import {getErrors} from './../../../../utils';
import plus from '../../../../assets/icons/button/plus.png';
import deleteIcon from '../../../../assets/icons/actionsbutton/delete.png';
import Popup from '../../../../components/ui/Popup';
import LocationPopup from './LocationPopup';
import ContractorCategoryPopup from './ContractorCategoryPopup';

const NewContractorPopup = ({
    setView,
    userData,
    toBeUpdated,
    refreshData
}) => {
    // -- states --
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const [locations, setLocations] = useState(null);
    const [contractorCategories, setContractorCategories] = useState([]);
    const [ressources, setRessources] = useState(null);
    const [contactValues, setContactValues] = useState([
        {id: Math.random(), name: "", email: "", phone: ""}
    ]);
    const [saleInputsInvalidity, setSaleInputsInvalidity] = useState(false);

    const [locationPopupView, setLocationPopupView] = useState(false);
    const [contractorCategoryPopupView, setContractorCategoryPopupView] = useState(false);

    // -- react hook form --
    const defaultValues = {
        name: '',
        location:'',
        internal_contacts: '',
        categories: "",
        note: "",
        address: "",
        country: countries.find(country => country.code === 'FR'),
        city: "",
        postal_code: "",
        reg_no: ""
    };

    const {handleSubmit, control, reset, formState: {isValid}} = useForm({defaultValues: defaultValues});

    // -- functions that get data for Select Inputs --
    const handleGetLocations = async (search, page) => {
        await fetchSelectData({
            action: LocationActions.getAllLocation,
            search:`&search=${search}&is_active=true`,
            page: page,
            setter: setLocations,
            userData,
            resultPath: "data"
        });
    };

    const handleGetContractorCategories = async (search, page) => {
        await fetchSelectData({
            action: ContractorCategoryActions.getAllContractorCategories,
            search:`&search=${search}&is_active=true`,
            page: page,
            setter: setContractorCategories,
            userData,
            resultPath: "data.results"
        });
    };

    const handleGetRessources = async (search, page) => {
        await fetchSelectData({
            action: UserActions.getAllSortedUsers,
            search:`&search=${search}`,
            page: page,
            setter: setRessources,
            userData,
            resultPath: "data.results"
        });
    };

    const handleAddContact = () => {
        if (contactValues.length < 10) {
            setContactValues((prevState) => [...prevState, {id: Math.random(), name: "", email: "", phone: ""}]);
        }
    }

    const handleRemoveContact = (id) => {
        setContactValues((prevState) => prevState.filter((element) => element.id !== id));
    }

    const handleContactValueChange = (e, id, type) => {
        setContactValues((prevState) => prevState.map((el) => el.id === id ? { ...el, [type]: e}  : el));
    }

    useEffect(() => {
        if (toBeUpdated) {
            if (toBeUpdated.contacts?.length > 0) {
                setContactValues(toBeUpdated.contacts.map((contact) => {
                    return (
                        {
                            id: Math.random(),
                            name: contact.name,
                            email: contact.email,
                            phone: contact.phone
                        }
                    );
                }));
            }
            reset({
                name: toBeUpdated.name,
                location: {name: toBeUpdated.location},
                internal_contacts: toBeUpdated.internal_contacts,
                categories: toBeUpdated.categories.map(el => { return {name: el} }),
                notes: toBeUpdated.notes,
                address: toBeUpdated.address,
                country: toBeUpdated.country ? countries.find(country => country.code === toBeUpdated.country) : countries.find(country => country.code === 'FR'),
                city: toBeUpdated.city,
                postal_code: toBeUpdated.postal_code,
                reg_no: toBeUpdated.reg_no || ""
            });
        }

    }, [toBeUpdated]);

    const checkSaleInputsValidity = () => {
        let invalid = false;

        for(const contact of contactValues) {
            if (contact.name.length < 1 || contact.email.length < 1 || contact.phone.length < 1) {
                invalid = true;
            }
        }

        setSaleInputsInvalidity(invalid);
    }

    useEffect(() => {
        checkSaleInputsValidity();
    }, [contactValues]);

    // Submit form
    const onSubmit = async (data) => {
        setErrors(null);
        setDisabled(true);
        setLoading(true);

        const internal_contacts_ids = data.internal_contacts.map((el) => {
            return el.id;
        });

        const categories = data.categories.map((el) => {
            return el.name;
        });

        const contacts = contactValues.map((contact) => {
            return (
                {
                    email: contact.email,
                    name: contact.name,
                    phone: contact.phone
                }
            );
        });

        const newContractor = {
            name: data.name,
            location: data.location.name,
            internal_contacts_ids,
            categories,
            contacts,
            notes: data.notes,
            address: data.address,
            country: data.country.code,
            city: data.city,
            postal_code: data.postal_code,
            reg_no: data.reg_no.trim()
        }

        if (toBeUpdated) {
            const result = await ContractorActions.updateContractor(userData, newContractor, toBeUpdated.id);

            if (!result.success) {
                setErrors(getErrors(result));
            }
            else {
                await refreshData('', 1);
                setView(false);
                notify('Le sous/co-traitant à bien été mis à jour');
            }
        }
        else {
            const result = await ContractorActions.createContractor(userData, newContractor);

            if (!result.success) {
                setErrors(getErrors(result));
            }
            else {
                await refreshData('', 1);
                setView(false);
                notify('Le sous/co-traitant à bien été créé');
            }
        }

        setLoading(false);
        setDisabled(false);
    }

    return (
        <div>
            <ContainerCard
                title='Nouveau Sous/Co-traitant'
                coloredButtonDisplayed={false}
                overflow='overflow-visible'
            >
                <div className="flex flex-col px-4 pt-2 pb-4">
                    <div className='flex flex-col justify-between pb-4 mb-4 border-b border-borderGrey'>
                        <div className="mb-2 w-full">
                            <Controller
                                name="name"
                                control={control}
                                rules={{required: {
                                    value: true,
                                    message: 'Veuillez saisir le nom'
                                }}}
                                render={({
                                    field: {onChange, value},
                                    fieldState: {error}
                                }) => (
                                    <TextInput
                                        label='Nom de la structure'
                                        labelWidth='w-[200px]'
                                        onChange={onChange}
                                        value={value}
                                        error={error}
                                        required={true}
                                        disabled={disabled}
                                        placeholder="Nom de la structure"
                                        type="text"
                                        width='w-[800px]'
                                    />
                                )}
                            />
                        </div>
                        <div className="flex mb-2 w-full">
                            <Controller
                                name="categories"
                                control={control}
                                rules={{required: {
                                    value: true,
                                    message: 'Veuillez selectionner au moins une catégorie'
                                }}}
                                render={({
                                    field: {onChange, ref, value},
                                    fieldState: {error}
                                }) => (
                                    <SelectInput
                                        label='Domaines'
                                        labelWidth='w-[190px]'
                                        placeholder='Domaines'
                                        inputRef={ref}
                                        error={error}
                                        value={value}
                                        options={contractorCategories?.options}
                                        hasNextPage={contractorCategories?.hasNextPage}
                                        onChange={onChange}
                                        fetchFunction={handleGetContractorCategories}
                                        labelKeys={['name']}
                                        required={true}
                                        disabled={disabled}
                                        isSearchable={true}
                                        isMulti={true}
                                        height='h-auto'
                                        width='w-auto min-w-[250px]'
                                    />
                                )}
                            />
                            <div className='flex justify-center items-center ml-3 w-fit'>
                                <Tooltip title='Ajouter une catégorie de prestataire'>
                                    <button
                                        onClick={() => setContractorCategoryPopupView(true)}
                                        disabled={disabled}
                                        // className={`hover:opacity-90 p-2 rounded-full ${blueStyle ? 'background-gradient-blue' : 'background-gradient'}`}
                                        className={`p-1 rounded-full hover:opacity-90 background-gradient`}
                                    >
                                        <img src={plus} alt='plus' className='w-3'/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        <div className="flex mb-2 w-full flex-start">
                            <Controller
                                name="location"
                                control={control}
                                rules={{required: {
                                    value: true,
                                    message: 'Veuillez saisir un client'
                                }}}
                                render={({
                                    field: {onChange, ref, value},
                                    fieldState: {error}
                                }) => (
                                    <SelectInput
                                        label='Département du siège'
                                        labelWidth='w-[190.5px]'
                                        placeholder='Département du siège'
                                        inputRef={ref}
                                        error={error}
                                        value={value}
                                        options={locations?.options}
                                        hasNextPage={locations?.hasNextPage}
                                        onChange={onChange}
                                        fetchFunction={handleGetLocations}
                                        labelKeys={['name']}
                                        required={true}
                                        disabled={disabled}
                                        isSearchable={true}
                                        width='w-[250px]'
                                    />
                                )}
                            />
                            <div className='flex justify-center items-center ml-3'>
                                <Tooltip title='Ajouter un département'>
                                    <button
                                        onClick={() => setLocationPopupView(true)}
                                        disabled={disabled}
                                        // className={`hover:opacity-90 p-2 rounded-full ${blueStyle ? 'background-gradient-blue' : 'background-gradient'}`}
                                        className={`p-1 rounded-full hover:opacity-90 background-gradient`}
                                    >
                                        <img src={plus} alt='plus' className='w-3'/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    <div className="pb-4 mb-4 border-b border-borderGrey">
                        <div className="flex flex-row justify-between">
                            <div className="w-7/12">
                                <Controller
                                    name="address"
                                    control={control}
                                    rules={{required: {
                                        value: true,
                                        message: 'Veuillez saisir une adresse'
                                    }}}
                                    render={({
                                        field: {onChange, value},
                                        fieldState: {error}
                                    }) => (
                                        <TextInput
                                            label='Adresse'
                                            width='w-[595px]'
                                            onChange={onChange}
                                            value={value}
                                            error={error}
                                            required={true}
                                            disabled={disabled}
                                            placeholder="Adresse"
                                            type="text"
                                        />
                                    )}
                                />
                            </div>

                            <div className="w-4/12">
                                <Controller
                                    name="country"
                                    control={control}
                                    rules={{required: {
                                        value: true,
                                        message: 'Veuillez saisir un pays'
                                    }}}
                                    render={({
                                        field: {onChange, ref, value},
                                        fieldState: {error}
                                    }) => (
                                        <SelectInput
                                            width='w-[188px]'
                                            label='Pays'
                                            placeholder='Pays'
                                            inputRef={ref}
                                            value={value}
                                            error={error}
                                            options={countries}
                                            onChange={onChange}
                                            labelKeys={['name']}
                                            required={true}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className="flex flex-row justify-between">
                            <div className="mt-3 w-7/12">
                                <Controller
                                    name="city"
                                    control={control}
                                    rules={{required: {
                                        value: true,
                                        message: 'Veuillez saisir une ville'
                                    }}}
                                    render={({
                                        field: {onChange, value},
                                        fieldState: {error}
                                    }) => (
                                        <TextInput
                                            label='Ville'
                                            width="w-[595px]"
                                            onChange={onChange}
                                            value={value}
                                            error={error}
                                            required={true}
                                            disabled={disabled}
                                            placeholder="Ville"
                                            type="text"
                                        />
                                    )}
                                />
                            </div>

                            <div className="mt-3 w-4/12">
                                <Controller
                                    name="postal_code"
                                    control={control}
                                    rules={{required: {
                                        value: true,
                                        message: 'Veuillez saisir un code postal'
                                    }}}
                                    render={({
                                        field: {onChange, value},
                                        fieldState: {error}
                                    }) => (
                                        <TextInput
                                            label='Code postal'
                                            width='w-[250px]'
                                            onChange={onChange}
                                            value={value}
                                            error={error}
                                            required={true}
                                            disabled={disabled}
                                            placeholder="Code postal"
                                            type="text"
                                            labelWidth='w-52'
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="flex flex-row justify-between">
                            <div className="mt-3 w-7/12">
                                <Controller
                                    name="reg_no"
                                    control={control}
                                    rules={{
                                        validate: value => {
                                            if (!value) return true;

                                            const cleaned = String(value).trim();

                                            if (!/^[0-9]+$/.test(cleaned)) {
                                                return "Le SIRET ne doit contenir que des chiffres";
                                            }

                                            if (cleaned.length !== 14) {
                                                return "Le SIRET doit contenir exactement 14 chiffres";
                                            }

                                            return true;
                                        }
                                    }}
                                    render={({
                                        field: { onChange, value },
                                        fieldState: { error }
                                    }) => (
                                        <TextInput
                                            label="SIRET"
                                            width="w-[800px]"
                                            onChange={onChange}
                                            value={value}
                                            error={error}
                                            disabled={disabled}
                                            placeholder="SIRET (14 chiffres)"
                                            type="text"
                                            labelWidth="w-48"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="pb-4 w-full border-b border-borderGrey">
                        <Controller
                            name="internal_contacts"
                            control={control}
                            rules={{required: {
                                value: true,
                                message: 'Veuillez selectionner au moins un contact interne'
                            }}}
                            render={({
                                field: {onChange, ref, value},
                                fieldState: {error}
                            }) => (
                                <SelectInput
                                    label='Référent(s)'
                                    labelWidth='w-[200px]'
                                    width='w-[755px]'
                                    placeholder='Référents'
                                    inputRef={ref}
                                    error={error}
                                    value={value}
                                    options={ressources?.options}
                                    hasNextPage={ressources?.hasNextPage}
                                    fetchFunction={handleGetRessources}
                                    onChange={onChange}
                                    labelKeys={['first_name', 'last_name']}
                                    isSearchable={true}
                                    disabled={disabled}
                                    required={true}
                                    isMulti={true}
                                    height="h-auto"
                                />
                            )
                            }
                        />
                    </div>
                </div>

                <div className="px-5">
                    <div>
                        {
                            contactValues.map((contact, index) => {
                                return (
                                    <div key={contact.id} className='mb-3.5 w-full'>
                                        <div>
                                            <TextInput
                                                label='Nom contact partenaire'
                                                labelWidth='w-[235px]'
                                                onChange={(e) => handleContactValueChange(e, contact.id, 'name')}
                                                value={contact.name}
                                                error={null}
                                                required={true}
                                                width='w-full'
                                                disabled={disabled}
                                                placeholder="Nom contact partenaire"
                                                type="text"
                                            />
                                        </div>
                                        <div className="flex justify-between mt-2 w-full">
                                            <TextInput
                                                label='Email du contact'
                                                labelWidth='w-[187px]'
                                                onChange={(e) => handleContactValueChange(e, contact.id, 'email')}
                                                value={contact.email}
                                                error={null}
                                                required={true}
                                                disabled={disabled}
                                                placeholder="Email"
                                                type="text"
                                            />
                                            <TextInput
                                                label='Téléphone du contact'
                                                labelWidth='w-[200px]'
                                                onChange={(e) => handleContactValueChange(e, contact.id, 'phone')}
                                                value={contact.phone}
                                                error={null}
                                                required={true}
                                                disabled={disabled}
                                                placeholder="Téléphone"
                                                type="text"
                                            />
                                        </div>
                                        {
                                            index === 0 ?
                                                null
                                                : <button
                                                    onClick={() => handleRemoveContact(contact.id)}
                                                    disabled={disabled}
                                                    className="flex justify-center items-center p-1 bg-transparent"
                                                >
                                                    <Tooltip title='Supprimer'>
                                                        <div>
                                                            <img src={deleteIcon} alt="logo" className="w-[18px]"/>
                                                        </div>
                                                    </Tooltip>
                                                </button>
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className='flex items-center mb-4'>
                        <Tooltip title='Ajouter un contact'>
                            <div
                                onClick={handleAddContact}
                                className={`whitespace-nowrap cursor-pointer text-sm text-gradient ${contactValues.length < 10 ? "text-[#646464]" : "text-[#b2bec3]"}`}
                            >
                                <p className='hover:underline'>Ajouter un contact</p>
                            </div>
                        </Tooltip>
                    </div>
                </div>

                <div className="px-5">
                    <div className={'py-4 border-t border-borderGrey'}>
                        <Controller
                            name="notes"
                            control={control}
                            render={({
                                field: {onChange, value}
                            }) => (
                                <>
                                    <div className="font-normal text-sm text-[#646464] mb-2">Veuillez ajouter une note</div>
                                    <TextAreaInput
                                        placeholder={'Tapez votre texte'}
                                        maxLength={500}
                                        height='h-[150px]'
                                        onChange={onChange}
                                        value={value}
                                        disabled={disabled}
                                    />
                                </>
                            )}
                        />
                    </div>
                </div>
                <div className="flex flex-col justify-center pb-2 mt-2">
                    <div className="flex justify-center pb-2">
                        <Button
                            onClick={() => setView(false)}
                            type={'secondary'}
                            content={'Annuler'}
                            disabled={disabled}
                        />
                        <Button
                            type={'primary'}
                            content={toBeUpdated ? "Modifier le sous/co-traitant" : 'Créer le sous/co-traitant'}
                            onClick={handleSubmit(onSubmit)}
                            loading={loading}
                            disabled={!isValid || saleInputsInvalidity || contactValues.length < 1}
                        />
                    </div>
                    <Error errors={errors}/>
                </div>
            </ContainerCard>
            <Popup
                view={locationPopupView}
                setView={setLocationPopupView}>
                <LocationPopup
                    setView={setLocationPopupView}
                    userData={userData}
                    refreshData={handleGetLocations}
                />
            </Popup>
            <Popup
                view={contractorCategoryPopupView}
                setView={setContractorCategoryPopupView}>
                <ContractorCategoryPopup
                    setView={setContractorCategoryPopupView}
                    userData={userData}
                    refreshData={handleGetContractorCategories}
                />
            </Popup>
        </div>
    );
}

export default NewContractorPopup;
